export const STANDARD_SHIPPING = 'Standard';
export const FLASH_SHIPPING = 'Flash';
export const MADE_TO_ORDER_SHIPPING = 'MTO';
export const EXPEDITED_SHIPPING = 'Expedited';

export const SHIPPING_DAYS = {
  [STANDARD_SHIPPING]: 14,
  [FLASH_SHIPPING]: 5,
  [MADE_TO_ORDER_SHIPPING]: 28,
  [EXPEDITED_SHIPPING]: 11,
  standard: 14,
  expedited: 11,
  flash: 5,
  mto: 28,
};

export const SHIPPING_DAYS_MIN = {
  [STANDARD_SHIPPING]: 11,
  [FLASH_SHIPPING]: 5,
  [MADE_TO_ORDER_SHIPPING]: 25,
  [EXPEDITED_SHIPPING]: 9,
  standard: 11,
  expedited: 9,
  flash: 5,
  mto: 25,
};

export const FLASH_SHIPPING_ELIGIBLE_MAX_COLOR_THRESHOLD = 3;

export const DECORATING_EXPEDITED_DISABLE =
  'Products with decorating methods are very exclusive and take time to be created, so they cannot be expedited. If you want them sooner, please reach out to us.';
export const DECORATING_FLASH_DISABLE =
  "Products with decorating methods are very exclusive and take time to be created, so they don't support Flash shipping. If you want them sooner, please reach out to us.";
export const MTO_STANDARD_DISABLE =
  'Made-to-order items are exclusive and take time to be manufactured, so they cannot be standard shipped. If you want them sooner, please reach out to us.';
export const MTO_FLASH_DISABLE =
  'Made-to-order items are exclusive and take time to be manufactured, so they cannot be shipped in 5 days. If you want them sooner, please reach out to us.';
export const MTO_EXPEDITED_DISABLE =
  'Made-to-order items are exclusive and take time to be manufactured, so they cannot be expedited. If you want them sooner, please reach out to us.';
export const FLASH_DISABLE =
  'The order can’t be flash shipped because one or more items aren’t flash items. Reach out to your account manager if you need help.';
export const FLASH_DISABLE_COLOR_RESTRICTION =
  'We can only do flash delivery if your art has three colors or less';

export const LACE_MTO_ONLY_DISABLE =
  "This product's lace color is made-to-order and can only ship via MTO.";

/** Shown when shipping-timeline API marks a ship type as not eligible for the order */
export const SHIPPING_METHOD_NOT_ELIGIBLE = 'This shipping method is not available for your order.';

/**
 * This function returns the tooltip for the flash disable
 * @param isMoreThanThreeColors
 * @param isAllFlash
 * @returns
 */
export const getFlashDisableTooltip = (isMoreThanThreeColors: boolean, isAllFlash: boolean) => {
  if (isMoreThanThreeColors) {
    return FLASH_DISABLE_COLOR_RESTRICTION;
  }
  if (isAllFlash) {
    return FLASH_DISABLE;
  }

  return '';
};

export const STANDARD_SHIPPING_KEY = 'standard';
export const FLASH_SHIPPING_KEY = 'flash';
export const MADE_TO_ORDER_SHIPPING_KEY = 'mto';
export const EXPEDITED_SHIPPING_KEY = 'expedited';
export const ECONOMY_SHIPPING_KEY = 'economy';

/** Label prefix used inside the economy shipping method card chip (action-oriented) */
export const ECONOMY_SHIPPING_SAVE_LABEL = 'SAVE';

/** Label prefix used in the price summary pill once economy shipping is applied */
export const ECONOMY_SHIPPING_SAVED_LABEL = 'SAVED';
/** Label shown under negative economy shipping amount in summaries */
export const ECONOMY_SHIPPING_SAVINGS_LABEL = 'Savings';

/** Ship types that automatically have guarantee selected with FREE fee */
export const AUTO_GUARANTEE_SHIP_TYPES: Array<string> = ['flash', 'expedited'];
